// extracted by mini-css-extract-plugin
module.exports = {"group":"Hero_group__SnGhx","mainFormClass":"Hero_mainFormClass__xdrph","label":"Hero_label__J4V6r","input":"Hero_input__xK8gj","bar":"Hero_bar__QXdMk"};